import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Trophy, Crown, ArrowLeft, Medal } from "lucide-react";

const pct = (v, d = 1) => v == null ? "—" : `${v.toFixed(d)}%`;

export default function CornerRanking() {
  const [data, setData] = useState({ ranking: [], period: null });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/kpi/corner-ranking").then(r => setData(r.data)).finally(() => setLoading(false));
  }, []);
  if (loading) return <div className="text-slate-400 text-center py-12">Chargement du classement…</div>;
  return (
    <div className="space-y-4" data-testid="corner-ranking-page">
      <Link to="/kpi-corner" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-slate-900">
        <ArrowLeft className="w-4 h-4"/> Retour au tableau
      </Link>
      <div className="bg-gradient-to-r from-amber-400 to-orange-500 rounded-2xl p-5 text-white">
        <div className="flex items-center gap-3">
          <Trophy className="w-8 h-8"/>
          <div>
            <div className="text-[11px] font-bold uppercase opacity-80">Classement National</div>
            <h1 className="font-display text-2xl font-bold">Wasascore · {data.period || "—"}</h1>
            <div className="text-xs opacity-90 mt-0.5">{data.ranking.length} corners classés</div>
          </div>
        </div>
      </div>
      <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
        <div className="max-h-[70vh] overflow-y-auto">
          {data.ranking.map((r, i) => (
            <div key={r.stand} className={`flex items-center gap-3 px-4 py-3 border-b border-slate-100 ${i < 3 ? "bg-gradient-to-r from-amber-50 to-white" : ""}`}
                 data-testid={`rank-${r.rank}`}>
              <div className={`w-8 h-8 grid place-items-center rounded-full text-white font-bold text-xs ${i === 0 ? "bg-amber-500" : i === 1 ? "bg-slate-400" : i === 2 ? "bg-orange-400" : "bg-slate-300"}`}>
                {i < 3 ? <Crown className="w-4 h-4"/> : r.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-slate-900 truncate">{r.stand}</div>
                <div className="text-[11px] text-slate-500">{r.sector} · BM {r.bm}</div>
              </div>
              <div className="text-right text-xs">
                <div className="text-slate-500">Foodcost {pct(r.foodcost)}</div>
                <div className="text-slate-500">Casse {pct(r.casse)}</div>
              </div>
              <div className="text-right ml-2">
                <div className="font-display text-lg font-bold text-slate-900">{r.score}</div>
                <div className="text-[10px] text-slate-500 uppercase">Score</div>
              </div>
            </div>
          ))}
          {data.ranking.length === 0 && <div className="text-center py-12 text-slate-400 italic">Aucune donnée pour le moment.</div>}
        </div>
      </div>
    </div>
  );
}
